/**
 * @author Aydin Cinar
 */

(function(app) {
    app.mapAnimation = (function() {
        var initialized = false;

        var position,
            random,
            limit = 0;


        var selectors = {
            mapDesc      : '#map-desc',
            turkeyMap    : '#turkey-map',
            city         : '#turkey-map .city'
        };



        var init = function() {
            initialized = true;

            app.$objs.turkeyMap  = $(selectors.turkeyMap);
            app.$objs.mapDesc  = $(selectors.mapDesc);
            app.$objs.city       = $(selectors.city);        


            bind();
        };

        var bind = function() {

            $(window).load(function () {
               findPosition();
               runOnScroll();
            });

            $(window).scroll(function() {
                runOnScroll();
            });

        };


        var findPosition  = function () {

            try {
                var containerPos = app.$objs.mapDesc.position() ;
                position = containerPos.top - 150;
            }
            catch(err) {}

        };

        var cityOpen = function() {
            app.$objs.city.each(function(index, el) {
                this.el = el;
                random = Math.floor(Math.random() * 9) / 10  ;
                TweenMax.to(el, random, {scale: '0.936'});
            });
        };


        var runOnScroll = function() {
            var scroll = $(document).scrollTop();

            if(scroll > position) {
                if(limit===0) {
                    cityOpen();
                }
                limit++;
            }
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('mapAnimation');
})(engelsizyasam);